export default "__VITE_ASSET__BoDB5fh$__"